import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { monthAndYear } from '../../../../../../../../../../../../shared/utils/formattedDates';
import { distanceBetween } from '../../../../../../../../../../../../shared/utils/helpers/distances';

import { Label } from 'hosman-material';
import { S_ChevronRight } from 'hosman-material';

import { updateModalPropertyId } from '../../../../../../../../../../../reducers/_Pages/Public/radarSlice';

const PopupContent = ({ property }) => {
  const { user } = useSelector((state) => state.user);
  const { coordinates } = useSelector((state) => state.radar);
  const dispatch = useDispatch()

  return (
    <div className='bg-ih-neutral-50/30 backdrop-blur-sm rounded-xl w-max relative cursor-pointer' onClick={() => dispatch(updateModalPropertyId(property.id))}>
      <div className='flex gap-6 p-2'>
        <img className='w-36 aspect-[1/1] object-cover rounded-xl' src={property.main_picture_url} />
        
        <div className='flex flex-col justify-between p-2'>
          <div className='flex flex-col gap-1 text-white'>
            <p className='font-semibold'>{property.kind_text} {property.room_number && `${property.room_number} pièces` }</p>
            <p>Vendu en {monthAndYear(property.oa_date)}</p>
          </div>

          <div className='flex items-center gap-2 text-ih-blue hover:text-ih-blue-80 text-lg font-semibold mb-2'>
            <p className='pb-1'>{user.id ? 'Voir le prix' : 'Débloquer la data'}</p>
            <FontAwesomeIcon icon={S_ChevronRight} />
          </div>

          {user.id &&
            <div className='absolute -bottom-1 left-1/2 -translate-x-1/2'>
              <p className='text-white px-2 py-1 bg-ih-indigo rounded-xl whitespace-nowrap'>{Math.round(property.area)} m²</p>
            </div>
          }
        </div>
      </div>

      <div className='absolute -top-3 -right-2'><Label color='bg-ih-blue'>A {distanceBetween(property.lat, property.lng, coordinates[1], coordinates[0])}</Label></div>
    </div>
  )
};

export default PopupContent;
